import { render } from "./Duihuan.vue?vue&type=template&id=2e5ee8fa&scoped=true"
import script from "./Duihuan.vue?vue&type=script&lang=js"
export * from "./Duihuan.vue?vue&type=script&lang=js"

import "./Duihuan.vue?vue&type=style&index=0&id=2e5ee8fa&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e5ee8fa"]])

export default __exports__